webpackJsonp([34727134076567],{

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavLink = __webpack_require__(12);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _NavLinkPlaceholder = __webpack_require__(13);
	
	var _NavLinkPlaceholder2 = _interopRequireDefault(_NavLinkPlaceholder);
	
	__webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var children = props.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'docs-header', id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'lore-generate-reducer'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Generates a new reducer in ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'src/reducers'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'docs-content' },
	        _react2.default.createElement(
	          'ul',
	          { id: 'markdown-toc' },
	          _react2.default.createElement(_NavLink2.default, { title: 'Introduction', url: '/cli/lore-generate-reducer/' })
	        ),
	        children
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreGenerateReducer = __webpack_require__(299);
	
	var _LoreGenerateReducer2 = _interopRequireDefault(_LoreGenerateReducer);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreGenerateReducer2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'generate reducer'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'CLI command to add an ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/reducers/' },
	        'Reducer'
	      ),
	      ' to your project.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate reducer [reducer-name]\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate reducer example\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The command above will generate a file located at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'src/reducers/example.js'
	      ),
	      ' that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import _ from \'lodash\';\n      import ActionTypes from \'../constants/ActionTypes\';\n      import PayloadStates from \'../constants/PayloadStates\';\n\n      const initialState = {\n        state: PayloadStates.INITIAL_STATE,\n        data: []\n      };\n\n      export default function(state = initialState, action) {\n        let nextState = _.assign({}, state);\n\n        switch (action.type) {\n          // case ActionTypes.FOUND_SOMETHING_COOL:\n          //   // push the cool things into the array of other cool things\n          //   return _.assign(nextState, {\n          //      data: nextState.data.concat(action.payload.data)\n          //    });\n\n          default:\n            return nextState\n        }\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cli-lore-generate-reducer-index-js-61be10ee4899f104557d.js